import React, { useMemo } from 'react'
import styled from 'styled-components'

import { AsyncStateN, Random } from '@blade/std-lib'
import { Skeleton } from '@blade/ui-kit'

type CellProps = {
  title: React.ReactNode
  className?: string
  value: AsyncStateN.AsyncStateN<unknown, React.ReactNode>
}
export const PairMetricsCell: React.FC<CellProps> = ({
  title,
  className,
  value,
}) => {
  const skeletonWidth = useMemo(() => Random.numberWithin(50, 70), [])

  const renderValue = (): React.ReactNode => {
    if (AsyncStateN.isError(value)) {
      return '-'
    }
    if (AsyncStateN.isSuccess(value)) {
      return value.value
    }
    return <Skeleton width={skeletonWidth} height={20} paddingBlock={3} />
  }

  return (
    <CellRoot className={className}>
      <Label>{title}</Label>
      <Value>{renderValue()}</Value>
    </CellRoot>
  )
}

const CellRoot = styled.div`
  padding-block-start: 8px;
  padding-inline-start: 18px;
`

const Label = styled.div`
  color: var(--background-2);
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
`

const Value = styled.div`
  color: var(--text-12);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`
